// extracted by mini-css-extract-plugin
export var footerBody = "vmBfI";
export var footerContainer = "Y00s9";
export var iconSize = "_1hoxY";
export var item = "dyyA4";
export var overflowFix = "wDETU";